import { Button } from "@/components/ui/button.tsx";
import { CalendarDays, X } from "lucide-react";
import { UI_CONSTANTS } from "./constants.ts";

interface ImplicitContextChipProps {
  label: string;
  onDismiss: () => void;
}

export const ImplicitContextChip: React.FC<ImplicitContextChipProps> = ({ label, onDismiss }) => {
  return (
    <div className="flex flex-wrap gap-1.5">
      <div className="group flex items-center gap-1.5 px-2 py-1 rounded-md border bg-slate-100 border-slate-200 text-slate-600 text-xs dark:bg-slate-800 dark:border-slate-700 dark:text-slate-300">
        <CalendarDays className={UI_CONSTANTS.ICON_SIZE_SM} />
        <span>{label}</span>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onDismiss}
          aria-label="Remove calendar context"
          className="p-0 h-auto hover:bg-slate-200 dark:hover:bg-slate-700 rounded"
          data-statsig-name="implicit-context-chip-dismiss"
        >
          <X className={UI_CONSTANTS.ICON_SIZE_SM} />
        </Button>
      </div>
    </div>
  );
};
